import { render, staticRenderFns } from "./VoyageInfo.vue?vue&type=template&id=7478ca39&scoped=true"
import script from "./VoyageInfo.vue?vue&type=script&lang=js"
export * from "./VoyageInfo.vue?vue&type=script&lang=js"
import style0 from "./VoyageInfo.vue?vue&type=style&index=0&id=7478ca39&prod&lang=scss&scoped=true"
import style1 from "./VoyageInfo.vue?vue&type=style&index=1&id=7478ca39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7478ca39",
  null
  
)

export default component.exports